import React from "react";
import { Dialog, DialogBody, Button, Box, Text } from "@dxp-feed/ui";

interface StoreUpdateDialogProps {
  isOpen: boolean;
  onClose: () => void;
  confirmStoreSelection: () => void;
  cancelStoreSelection: () => void;
  confrimLoading: boolean;
}

const StoreUpdateDialog: React.FC<StoreUpdateDialogProps> = ({
  isOpen,
  onClose,
  confirmStoreSelection,
  cancelStoreSelection,
  confrimLoading,
}) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      positionClass=""
      className="sm:max-w-[432px] mx-6 rounded-lg"
    >
      <DialogBody className="py-0">
        <Box className="text-brandBlack flex flex-col gap-3 text-body">
          <Box className="flex justify-between w-full items-center">
            <Text as="p" className="font-bold text-base mb-0">
              Update Selected Store
            </Text>
            <button
              onClick={onClose}
              className="!text-brandBlack text-xl !bg-none hover:text-gray-800 "
              aria-label={"Close Modal"}
            >
              <Text as="span" className="icon-close flex w-4 text-base" />
            </button>
          </Box>
          <Text as="p">Prices shown reflect in-store prices.</Text>
          <Text as="p" className="font-bold">
            Updating your selected store may result in changes to prices
            displayed on Sobeys.com
          </Text>
          <Text as="p" className="mb-3">
            Do you wish to continue?
          </Text>
          <Box className="flex gap-3 flex-col">
            {confrimLoading ? (
              <>
                <Button className="w-full font-normal 2xs:text-body px-6 min-h-10 text-sm cursor-not-allowed">
                  Updating store...
                </Button>
                <Button
                  className="w-full font-normal 2xs:text-body px-6 min-h-10 text-sm cursor-not-allowed"
                  variant="outline"
                  aria-label="No, maintain previously selected store"
                >
                  No, maintain previously selected store
                </Button>
              </>
            ) : (
              <>
                <Button
                  className="w-full font-normal 2xs:text-body px-6 min-h-10 text-sm"
                  onClick={confirmStoreSelection}
                  aria-label="Yes, continue updating selected store"
                >
                  Yes, continue updating selected store
                </Button>
                <Button
                  className="w-full font-normal 2xs:text-body px-6 min-h-10 text-sm"
                  variant="outline"
                  onClick={cancelStoreSelection}
                  aria-label="No, maintain previously selected store"
                >
                  No, maintain previously selected store
                </Button>
              </>
            )}
          </Box>
        </Box>
      </DialogBody>
    </Dialog>
  );
};

export default StoreUpdateDialog;
